import { Check } from 'lucide-react';
import { useState, useEffect } from 'react';

const steps = ['Understanding', 'Searching', 'Analyzing', 'Generating'];

function ThinkingIndicator() {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((s) => (s < steps.length - 1 ? s + 1 : s));
    }, 1200);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="max-w-[82%] p-4 mb-3"
      style={{
        background: 'transparent',
        borderRadius: '16px 16px 16px 4px',
        border: 'none',
      }}
    >
      {/* Dots */}
      {/* <div className="flex items-center gap-1 mb-2">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="w-2 h-2 rounded-full"
            style={{
              background: '#00C8D4',
              animation: `pulse-dot 1.4s ease-in-out ${i * 0.2}s infinite`,
            }}
          />
        ))}
        <span className="text-[13px] ml-2" style={{ color: '#fff' }}>Processing your query...</span>
      </div> */}

      {/* Pipeline */}
      <div className="flex items-center gap-0 mt-3">
        {steps.map((step, i) => (
          <div key={step} className="flex items-center">
            <div className="flex flex-col items-center">
              <div
                className="w-5 h-5 rounded-full flex items-center justify-center text-[10px]"
                style={{
                  background: i < activeStep ? '#22c55e' : i === activeStep ? '#00C8D4' : 'rgba(0,0,0,0.15)',
                  color: 'white',
                  animation: i === activeStep ? 'thinking-pulse 1s ease-in-out infinite' : undefined,
                }}
              >
                {i < activeStep ? <Check size={10} /> : null}
              </div>
              <span className="text-[10px] mt-1" style={{ color: '#fff' }}>{step}</span>
            </div>
            {i < steps.length - 1 && (
              <div className="w-6 h-px mx-0.5 mt-[-12px]" style={{ background: 'transparent' }} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ThinkingIndicator;
